import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './core/components/auth/auth.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { NotAuthorizedComponent } from './shared/miscellaneous/not-authorized/not-authorized.component';
import { NotFoundComponent } from './shared/miscellaneous/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./home/home.routing').then((m) => m.HomeRoutingModule)
      },
      {
        path: 'main',
        loadChildren: () => import('./main/main.routing').then((m) => m.MainRoutingModule)
      },
      {
        path: 'shared',
        loadChildren: () => import('./shared/shared.module').then((m) => m.SharedModule)
      },
      {
        path: 'auth',
        component: AuthComponent
      },
      {
        path: 'auth/activate',
        component: AuthComponent
      },
      {
        path: 'auth/resetpassword',
        component: AuthComponent
      },
      //{ path: '**', component: AuthComponent }
      //{ path: 'pages/miscellaneous/notauthorized', component: AuthComponent }
      {
        path: 'notauthorized',
        component: NotAuthorizedComponent,
        canActivate: [AuthGuard]
      },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
